import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import HelpWidget from './HelpWidget';
import { useParams } from 'react-router-dom';

const Settings = () => {
    const {question} = useParams();

    return <>
        <TopBar left="/more" title="Help" />
        <Page>
            <HelpWidget prefill={question} />
        </Page>
    </>
}

export default Settings;
